import React from "react";

import { HookFormSocialLinksIndividualDate } from "./IndividualDate";
import { SocialPlatforms } from "./types";

import "./styles.scss";

export const HookFormSocialLinks = () => {
  return (
    <div className="hook-form-social-links">
      {SocialPlatforms.map((platform) => (
        <HookFormSocialLinksIndividualDate key={platform} platform={platform} />
      ))}
    </div>
  );
};
